__turbopack_context__.v({
  "grabberIcon": "TenThings-module__cQwz5W__grabberIcon",
  "item": "TenThings-module__cQwz5W__item",
  "itemMarker": "TenThings-module__cQwz5W__itemMarker",
  "list": "TenThings-module__cQwz5W__list",
});
